export const DOCUMENT_TYPE_CONFIG = {
    MEDABLE_FORMAT: {
        key: '2',
        title: 'MEDABLE_FORMAT Work in progress',
        description: 'Import Medable files (.json or .zip) using standard import.',
        isAIEnabled: false,
    },
    NON_MEDABLE_FORMAT: {
        key: '3',
        title: 'NON_MEDABLE_FORMAT Work in progress',
        description: 'Import external files (.doc, .docx, .xlsx, .json, .pdf) using AI import.',
        isAIEnabled: true,
    },
    MEDABLE_FORMAT_EXISTING_CLONE: {
        key: '4',
        title: 'MEDABLE_FORMAT_EXISTING Work in progress',
        description: 'Copy existing Medable translations using AI import.',
        isAIEnabled: true,
    },
    MEDABLE_FORMAT_EXISTING_VERSION: {
        key: '5',
        title: 'MEDABLE_FORMAT_EXISTING_VERSION Work in progress',
        description: 'Copy existing Medable translations using AI import.',
        isAIEnabled: true,
    },
    NO_OP: {
        key: '6',
        title: 'NO_OP Work in progress',
        description: 'Copy existing Medable translations using AI import.',
        isAIEnabled: true,
    },
};
